import { Box, Input, SxProps, TextField, Typography } from "@mui/material";
import React from "react";
import { StoreData } from "../../Objects/StoreInterface";
import { StudioData } from "../../Objects/StudioInterface";

interface ImagePickerProps {
    sx?: SxProps,
    imageSx?: SxProps,
    imageData?: string,
    onChange: (data: any) => void,
}

const ImagePicker: React.FC<ImagePickerProps> = ({
    sx,
    imageSx,
    imageData,
    onChange,
}) => {
    return (
        <Box
            component="label"
            sx={{
                display: "block",
                width: 200,
                height: 200,
                background: "#fafafa",
                border: "1px solid silver",
                cursor: "pointer",
                ...sx,
            }}
        >
            {imageData ? (
                <Box
                    component="img"
                    sx={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        ...imageSx,
                    }}
                    src={imageData}
                />
            ) : (
                <Box
                    sx={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <Typography>選択</Typography>
                </Box>
            )}
            <Input
                type="file"
                sx={{
                    display: "none"
                }}
                onChange={ (e: React.ChangeEvent<HTMLInputElement>) => {
                    if( e.target.files && e.target.files[0] ) {
                        let reader = new FileReader();
                        reader.onload = event => {
                            if( event?.target?.result ) {
                                onChange(event.target.result)
                            }
                        }
                        reader.readAsDataURL(e.target.files[0]);
                    }
                }}
            />
        </Box>
    );
}

export default ImagePicker